import 'intl-tel-input/src/css/intlTelInput.scss';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils';
import $ from 'jquery';

/**
 * Auto-validatable International Telephone Input that works with Parsley.
 * [data-parsley-int-tel="true"] HTML attribute activates validation.
 */
export default class InterTel {
  constructor() {
    const $collection = $('.intl-tel-input');

    if ($collection.length) {
      if (window.Parsley instanceof Object) {
        window.Parsley
          .addValidator('intTel', {
            validateString: (value, requirement, { element }) => element.iti.isValidNumber(),
            requirementType: 'string'
          });
      }

      $collection.each(function () {
        // Initiating with custom settings
        this.iti = intlTelInput(this, {
          preferredCountries: ['au', 'nz', 'gb'],
          separateDialCode: true,
          initialCountry: 'au'
        });

        // Fixing intlTelInput issue on {separateDialCode: true}
        this.style.paddingLeft = '85px';

        // Workaround for whole number
        const $this = $(this);
        $this
          .after(`<input name="${$this.attr('name')}" hidden/>`)
          .removeAttr('name')
          .on('change', () => {
            const code = `+${this.iti.getSelectedCountryData().dialCode}`;
            const number = $this.val().replace(/^0/, '');

            $this.next('input').val(code + number);
          });

        // Populating default value
        this.iti.promise.then(() => $this.next('input').val($this.val()));
      });
    }
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/form/inter-tel.js